import React from "react";
import { Box, Grid, Typography } from "@mui/material";

function ExternalConnectionsDrawer(props) {
    const data = props.data || [];

    return (
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
            {data.map((item, index) => (
                <Grid container key={index} spacing={1} alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ fontStyle: "italic", fontSize: 14 }}>
                            {item.label}
                        </Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography variant="body2" sx={{ fontStyle: "italic", fontSize: 14 }}>
                            {item.value}
                        </Typography>
                    </Grid>
                </Grid>
            ))}
        </Box>
    );
}

export default ExternalConnectionsDrawer;
